import React, { useEffect } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { useTranslation } from 'react-i18next'
import { Image } from 'react-bootstrap'
import TF_logo from 'img/tf-logos/TF_logo.png'
import appConfig from 'app.config'

interface IIdleTimeOut {
	showModal: boolean
	handleClose: any
	handleLogout: any
	remainingTime: number
}

interface ITime {
	seconds: number
	minutes: number
}

export const IdleTimeOutModal = ({
	showModal,
	handleClose,
	handleLogout,
	remainingTime,
}: IIdleTimeOut) => {
	const { t } = useTranslation()
	const [time, setTime] = React.useState<ITime>({
		seconds: remainingTime,
		minutes: 0,
	})

	useEffect(() => {
		const interval = setInterval(() => {
			if (showModal) {
				if (time.seconds % 2) {
					document.title = t('IdleTimeout')
				} else {
					document.title = t('Title')
				}

				if (time.seconds > 0) {
					setTime((prev) => ({
						...prev,
						seconds: time.seconds - 1,
					}))
				} else {
					handleLogout()
				}
			}
		}, 1000)
		return () => clearInterval(interval)
	})

	function clearCounterAndHandleClose() {
		setTime((prev) => ({
			...prev,
			seconds: remainingTime,
		}))
		document.title = t('Title')
		handleClose()
	}

	return (
		<Modal
			show={showModal}
			onHide={clearCounterAndHandleClose}
			animation={false}
			centered
			className={`${appConfig.country} idletimeout-modal`}
			backdrop="static">
			<Modal.Header closeButton>
				<div>
					<Image
						src={TF_logo}
						className="img-responsive logo"
						alt="logo"
					/>
				</div>
			</Modal.Header>
			<Modal.Body>
				<div className="d-flex justify-content-center flex-column align-items-center text-center text-md py-3">
					<div>{t('LogoutWarning', { time })}</div>
					<div className="d-flex justify-content-center m-3">
						<div className="loading"></div>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer className="d-flex justify-content-between">
				<Button variant="secondary" onClick={handleLogout}>
					{t('Logout')}
				</Button>
				<Button variant="primary" onClick={clearCounterAndHandleClose}>
					{t('Reactivate')}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}